import { IGlobalState } from '../../Root/store/appReducer'

export const getCurrentRoute = (state: IGlobalState) => state.router.location
